import React, { useState, useEffect } from "react";

var VISIBLE_DOTS = 5;
var DOT_SIZE = 12;
var DOT_GAP = 6;

var DynamicDots = function ({ total, classes, sliderRef }) {
  var _state = useState({ idx: 0, count: total });
  var slideState = _state[0];
  var setSlideState = _state[1];

  useEffect(
    function () {
      var el = sliderRef && sliderRef.current;
      if (!el) return;

      var loop = setInterval(function () {
        try {
          var slider = window.UIkit && window.UIkit.slider(el);
          if (!slider || typeof slider.index !== "number") return;
          var newIdx = slider.index;
          var newCount =
            typeof slider.maxIndex === "number"
              ? slider.maxIndex + 1
              : total;
          setSlideState(function (prev) {
            if (prev.idx === newIdx && prev.count === newCount) return prev;
            return { idx: newIdx, count: newCount };
          });
        } catch (e) {}
      }, 150);

      return function () {
        clearInterval(loop);
      };
    },
    [sliderRef, total]
  );

  var slideCount = slideState.count;
  var idx = slideState.idx;

  if (slideCount <= 1) return null;

  var handleClick = function (index) {
    try {
      var el = sliderRef && sliderRef.current;
      var slider = el && window.UIkit && window.UIkit.slider(el);
      if (slider) slider.show(index);
    } catch (e) {}
  };

  var dots = [];
  for (var i = 0; i < slideCount; i++) {
    var distance = Math.abs(i - idx);
    var cls = classes.dotFar;
    if (distance === 0) cls = classes.dotActive;
    else if (distance === 1) cls = classes.dotNear;

    dots.push(
      <span
        key={i}
        className={classes.dot + " " + cls}
        style={{
          transform:
            "scale(" +
            (distance === 0 ? 1 : distance === 1 ? 0.66 : 0.42) +
            ")",
          flexShrink: 0,
        }}
        onClick={handleClick.bind(null, i)}
      />
    );
  }

  if (slideCount <= VISIBLE_DOTS) {
    return <div className={classes.pagination}>{dots}</div>;
  }

  var dotStep = DOT_SIZE + DOT_GAP;
  var viewWidth = VISIBLE_DOTS * DOT_SIZE + (VISIBLE_DOTS - 1) * DOT_GAP;
  var trackWidth = slideCount * DOT_SIZE + (slideCount - 1) * DOT_GAP;

  var centerOffset = (viewWidth - DOT_SIZE) / 2;
  var tx = -(idx * dotStep) + centerOffset;
  if (tx > 0) tx = 0;
  if (tx < -(trackWidth - viewWidth)) tx = -(trackWidth - viewWidth);

  return (
    <div className={classes.pagination}>
      <div style={{ overflow: "hidden", width: viewWidth + "px" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: DOT_GAP + "px",
            transform: "translateX(" + tx + "px)",
            transition: "transform 0.3s ease",
          }}
        >
          {dots}
        </div>
      </div>
    </div>
  );
};

export default DynamicDots;
